import { Pipe, PipeTransform } from '@angular/core'
import { RecurrenceEditingHelper, RecurrenceEditingMode } from '../recurrenceEditing'

@Pipe({
  name: 'humanizeRecurrenceEditingMode',
  pure: true,
  standalone: true,
})
export class HumanizeRecurrenceEditingModePipe implements PipeTransform {
  transform(value: RecurrenceEditingMode): string {
    return RecurrenceEditingHelper.humanize(value)
  }
}
